

const { combineReducers, createStore } = require('redux')
const reducers = require('./reducers')

const mainStore = combineReducers(reducers)
const initialState = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) ? window.__REDUX_DEVTOOLS_EXTENSION__() : {}

module.exports = createStore(mainStore, initialState)



// WEBPACK FOOTER //
// ./shared/stores/index.js